/**
 * beforeunload（タブ閉じ／ページ遷移）直前の保存用の HTTP 送信。
 *
 * axios を使わない理由:
 *   本プロジェクトの axios (0.21.x) はデフォルトアダプタが XMLHttpRequest ベースで、
 *   XHR には keepalive 概念がないため beforeunload 中に発火したリクエストはブラウザに abort される。
 *   結果として「保存したつもりが保存されていない」挙動になる。
 *   Fetch API の `keepalive: true` オプションはページ解体後もブラウザがリクエストを完了させることを
 *   仕様で保証するため、unload 時の書き込みにはこちらを用いる。
 *   (axios 1.7+ には fetch adapter があり keepalive 対応が可能だが、本プロジェクトは 0.21.x で未対応)
 *
 * 制約:
 *   - レスポンスボディは unload 中は読めないことが多い（新規作成時にサーバ割当 ID を取得不可）
 *   - CSRF インターセプタを経由しないため Codmon-CSRF-Token ヘッダを手動付与（POST のみ必須、PUT は任意）
 *   - axios インターセプタで自動付与される `?__env__=mgr` も URL に手動で付与する
 *     （サーバ側で CSRF feature flag 判定に使われるため。未指定だと feature flag ON でも判定がスキップされる）
 */
export const fetchWithKeepAlive = (url: string, method: 'POST' | 'PUT', body: unknown): Promise<Response> => {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  const csrfToken = localStorage.getItem('CODMON-CSRF-TOKEN');
  if (csrfToken) {
    headers['Codmon-CSRF-Token'] = csrfToken;
  }
  return fetch(url, {
    keepalive: true,
    method,
    credentials: 'same-origin',
    headers,
    body: JSON.stringify(body),
  });
};
